import React, { useState, useEffect } from 'react';
import {
    Button,
    Col,
    Input,
    Row,
    Label,
    ModalBody,
    Form,
    TabPane,
    TabContent,
    FormFeedback,
    FormGroup,
    ModalFooter,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import OSelect from '../../../Components/OElements/OSelect';
import { getUtmZoneList, getGeodeticDatumList } from '../../../slices/thunks';

const RestitutionCoordinatesForm = ({
    dataCoordinates,
    handleToggleModal,
    isEdit,
    isOpen,
    handleSave
}) => {
    
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUtmZoneList());
        dispatch(getGeodeticDatumList());
    }, [dispatch]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: dataCoordinates?.name || '',
            utm_north_restitution: dataCoordinates?.utm_north_restitution || '',
            utm_east_restitution: dataCoordinates?.utm_east_restitution || '',
            utm_zone_id: dataCoordinates?.utm_zone_id || dataCoordinates?.utm_zone?._id || '',
            geodetic_datum_id: dataCoordinates?.geodetic_datum_id || dataCoordinates?.geodetic_datum?._id || '',
            latitude_restitution: dataCoordinates?.latitude_restitution || '',
            longitude_restitution: dataCoordinates?.longitude_restitution || '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Campo requerido'),
            utm_north_restitution: Yup.number().required('Campo requerido'),
            utm_east_restitution: Yup.number().required('Campo requerido'),
            utm_zone_id: Yup.string().required('Campo requerido'),
            geodetic_datum_id: Yup.string().required('Campo requerido'),
            latitude_restitution: Yup.number(),
            longitude_restitution: Yup.number(),
        }),
        onSubmit: async (values) => {
            const payload = {
                ...values,
                latitude_restitution: values.latitude_restitution !== '' ? Number(values.latitude_restitution) : null,
                longitude_restitution: values.longitude_restitution !== '' ? Number(values.longitude_restitution) : null,
            };
            handleSave(payload);
            validation.resetForm();
        },
    });

    return (
        <Form
            className='tablelist-form'
            onSubmit={e => {
                e.preventDefault();
                return false;
            }}
        >
            <ModalBody className='modal-body'>
                <TabContent activeTab={'1'}>
                    <TabPane tabId='1'>
                        <Row className='g-3'>
                            <Col lg={12} className='mb-3'>
                                <Label for='name' className='form-label'>
                                    Nombre Coordenada <span className='text-danger'>*</span>
                                </Label>
                                <Input
                                    name='name'
                                    id='name'
                                    className='form-control'
                                    type='text'
                                    value={validation.values.name || ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.name && validation.errors.name}
                                />
                                {validation.touched.name && validation.errors.name && (
                                    <FormFeedback>{validation.errors.name}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <Label for='utm_north_restitution' className='form-label'>
                                    UTM Norte Restitución <span className='text-danger'>*</span>
                                </Label>
                                <Input
                                    name='utm_north_restitution'
                                    id='utm_north_restitution'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.utm_north_restitution ?? ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.utm_north_restitution && validation.errors.utm_north_restitution}
                                />
                                {validation.touched.utm_north_restitution && validation.errors.utm_north_restitution && (
                                    <FormFeedback>{validation.errors.utm_north_restitution}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <Label for='utm_east_restitution' className='form-label'>
                                    UTM Este Restitución <span className='text-danger'>*</span>
                                </Label>
                                <Input
                                    name='utm_east_restitution'
                                    id='utm_east_restitution'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.utm_east_restitution ?? ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.utm_east_restitution && validation.errors.utm_east_restitution}
                                />
                                {validation.touched.utm_east_restitution && validation.errors.utm_east_restitution && (
                                    <FormFeedback>{validation.errors.utm_east_restitution}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <OSelect
                                    key={`utm_zone_id`}
                                    label="Huso UTM"
                                    id="utm_zone_id"
                                    name="utm_zone_id"
                                    value={validation.values.utm_zone_id || ''}
                                    isRequired
                                    validation={validation}
                                    requestApi={() => dispatch(getUtmZoneList()).then(res => res.payload)}
                                />
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <OSelect
                                    key={`geodetic_datum_id`}
                                    label="Datum Geodésico"
                                    id="geodetic_datum_id"
                                    name="geodetic_datum_id"
                                    value={validation.values.geodetic_datum_id || ''}
                                    isRequired
                                    validation={validation}
                                    requestApi={() => dispatch(getGeodeticDatumList()).then(res => res.payload)}
                                />
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <Label for='latitude_restitution' className='form-label'>
                                    Latitud Restitución
                                </Label>
                                <Input
                                    name='latitude_restitution'
                                    id='latitude_restitution'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.latitude_restitution ?? ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.latitude_restitution && validation.errors.latitude_restitution}
                                />
                                {validation.touched.latitude_restitution && validation.errors.latitude_restitution && (
                                    <FormFeedback>{validation.errors.latitude_restitution}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <Label for='longitude_restitution' className='form-label'>
                                    Longitud Restitución
                                </Label>
                                <Input
                                    name='longitude_restitution'
                                    id='longitude_restitution'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.longitude_restitution ?? ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.longitude_restitution && validation.errors.longitude_restitution}
                                />
                                {validation.touched.longitude_restitution && validation.errors.longitude_restitution && (
                                    <FormFeedback>{validation.errors.longitude_restitution}</FormFeedback>
                                )}
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </ModalBody>
            <ModalFooter>
                <div className='hstack gap-2 justify-content-end'>
                    <Button
                        type='button'
                        onClick={() => {
                            handleToggleModal();
                        }} className='btn-danger btn-label'>
                        <i className="ri-close-line label-icon"></i>
                        Cancelar
                    </Button>
                    <button
                        type='button'
                        className='btn btn-label btn-primary'
                        onClick={() => {
                            validation.handleSubmit();
                        }}
                    >
                        <i className='ri-save-line label-icon'></i>
                        Guardar
                    </button>
                </div>
            </ModalFooter>
        </Form>
    );
};

export default RestitutionCoordinatesForm;
